import React from 'react'
import Quiz from './Quiz'
import { QuizAppProvider } from '../context/QuizContext'
import '../style.css'
const QuizHomeAPI = () => {
    return (
        <>
            <QuizAppProvider>
                <Quiz />
            </QuizAppProvider>

        </>
    )
}

export default QuizHomeAPI